import type { InvoiceReportReceiptType } from 'ap-openapi';
import type { UnifiedDocumentFile } from './types';

export interface DocumentMetadata {
  receiptType?: InvoiceReportReceiptType;
  eDocMeta?: unknown;
  showTimestamp: boolean;
}

/**
 * Extracts metadata from a document's mf_file for PDF preview
 */
export const extractDocumentMetadata = (
  mfFile?: UnifiedDocumentFile
): DocumentMetadata => {
  if (!mfFile) {
    return {
      receiptType: undefined,
      eDocMeta: undefined,
      showTimestamp: false,
    };
  }

  const receiptType = mfFile.receipt_type;
  const eDocMeta = mfFile.e_doc_meta_datum;

  const showTimestamp = mfFile.invoice_number
    ? !!eDocMeta && mfFile.timestamp_status === 'done'
    : mfFile.timestamp_status === 'done';

  return {
    receiptType,
    eDocMeta,
    showTimestamp,
  };
};
